import { Box } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { useParams } from "react-router";
import { useFacilitatorId } from "../../hooks/facilitator-id";
import { useFacilitatorName } from "../../hooks/facilitator-name";
import useFetchAttendancesGrades from "../../hooks/fetch-attendances-grades";

import AttendancesHeader from "./attendances-header";
import AttendancesGrades from "./attendances-grades";

const AttendancesPanel: FunctionComponent = (): JSX.Element => {
  const { facilitatorName } = useFacilitatorName();
  const { facilitatorId } = useFacilitatorId(facilitatorName);
  const { module } = useParams<{ module: string }>();

  const { attendancesGrades, refetchAttendancesGrade } = useFetchAttendancesGrades(facilitatorId);

  return (
    <Box backgroundColor="#f8f8f8" minH="100%" paddingX="2rem" paddingY="2rem" overflow="auto">
      {facilitatorId && module ? (
        <>
          <AttendancesHeader module={module} />

          <AttendancesGrades
            attendancesGrades={attendancesGrades || undefined}
            refetchAttendancesGrade={refetchAttendancesGrade}
          />
        </>
      ) : (
        <p>
          O facilitador que você procura não existe, tente buscar pelos nomes disponíveis na barra
          lateral.
        </p>
      )}
    </Box>
  );
};

export default AttendancesPanel;
